module.exports = __webpack_public_path__ + "img/main_hlw.6141630a.jpg";